import React, { useEffect, useState }  from 'react';
import styled from 'styled-components';
import { IconCalling } from '../../Assets/contacts/IconCalling';
import { Dictionery } from '../../Data/Dictionery';
import { IconSMS } from '../../Assets/contacts/IconSMS';
import { IconBuilding } from '../../Assets/contacts/IconBuilding';
import { IconInstagram } from '../../Assets/contacts/IconInstagram';
import { IconFacebook } from '../../Assets/contacts/IconFacebook';
import { IconYoutube } from '../../Assets/contacts/IconYoutube';
import { IconPhone } from '../../Assets/contacts/IconPhone';
import TourDetailsDatesCart from '../Carts/TourDetailsDatesCart';
import TourDetailsFacilityCart from '../Carts/TourDetailsFacilityCart';
import TourDetailsHotelsCart from '../Carts/TourDetailsHotelsCart';
import { IconLocation } from '../../Assets/contacts/IconLocation';
import { IconAgency } from '../../Assets/contacts/IconAgency';
import { setMetaTags, setReachDataType } from '../Functions/SetHeaders';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { IconRouting } from '../../Assets/panels/IconRouting';
import TourDetailsDatesCartV2 from '../Carts/TourDetailsDatesCartV2';
import TourDetailsFacilityCartV2 from '../Carts/TourDetailsFacilityCartV2';
import TourDetailsHotelsCartV2 from '../Carts/TourDetailsHotelsCartV2';
import TourDetailsTravelPlanCartV2 from '../Carts/TourDetailsTravelPlanCartV2';
import TourDetailsServicesCartV2 from '../Carts/TourDetailsServicesCartV2';
import { IconAds } from '../../Assets/panels/IconAds';
import { DictioneryPanel } from '../../Data/DictioneryPanel';
import { formatPrice } from '../Functions/Price';
import { IconWallet } from '../../Assets/panels/IconWallet';
import { IconWallet2 } from '../../Assets/panels/IconWallet2';
import { TextBtn2 } from '../Inputs/TextBtn2';
const Styles = styled.div`
  margin: 0 0 0.5rem;
  .back-drop {
    width: 100%;
    height: 30vh;
    height: 30lvh;
    overflow: hidden;
    border-radius:0 0 var(--border-radius-3) var(--border-radius-3);
    position: relative;
    isolation: isolate;
    background-color: var(--prime-1);
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
      filter: blur(10px);
    }
    &::after{
      z-index: 2;
      content: " ";
      position: absolute;
      inset: 0;
      background-color: #00000030;
    }
    margin-bottom: -10vh;
    margin-bottom: -10lvh;
  }
  .over-tour {
    width: calc(100% - calc(var(--universal-pad) * 2) - 0);
    margin: 0 var(--universal-pad) 1rem;
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 1.25rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    .base {
      width: calc(70% - 1rem);
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .title1 {
        font-size: 1.5rem;
        font-weight: 700;
      }
      .desc {
        text-decoration: none;
        color: inherit;
        display: flex;
        gap: 0.5rem;
        font-size: 0.9rem;
        font-weight: 600;
        &.big {
          margin-top: 0.3rem;
          font-size: 1.1rem;
        }
        .desc-link {
          color: var(--c-main);
        }
        svg {
          fill: var(--n-grey-2);
          width: 32px;
          height: 32px;
          display: block;
        }
        .text {
          width: calc(100% - 32px - 0.5rem);
          white-space: pre-line;
        }
      }
    }
    .image {
      width: 30%;
      max-width: 300px;
      aspect-ratio: 1.8;
      border: 1px solid var(--n-grey-1);
      border-radius: var(--border-radius-3);
      overflow: hidden;
      position: relative;
      background-color: var(--n-grey-01);
      .icon-def {
        position: absolute;
        top: calc(50% - 24px);
        right: calc(50% - 24px);
        display: block;
        fill: var(--n-grey-2);
        z-index: 1;
      }
      img {
        position: relative;
        z-index: 2;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .end {
      display: flex;
      justify-content: flex-end;
      gap: 1.25rem;
      .social {
        border-radius: 100px;
        border: 1px solid var(--n-grey-1);
        background-color: var(--n-grey-01);
        padding: 0.87rem;
        svg {
          display: block;
        }
      }
    }
  }
  .box-details {
    width: calc(100% - calc(calc(var(--universal-pad) - 1rem) * 2) );
    margin: 0 calc(var(--universal-pad) - 1rem) 1rem;
  }
  .buy {
    display: flex;
    padding: 1rem var(--universal-pad);
    background-color: var(--n-grey-0);
    position: fixed;
    inset: auto 0 0 0;
    z-index: 10;
    width: calc(100% - calc(var(--universal-pad) * 2));
    min-height: calc(60px - 2rem);
    box-shadow: var(--n-shadow-2);
    justify-content: space-between;
    .price {
      font-size: 1.2rem;
      font-weight: 700;
      color: var(--c-main);
      display: flex;
      gap: 0.5rem;
      align-items: center;
    }
    .actions {
      min-width: 150px;
      display: flex;
      align-items: center;
    }
  }
  @media screen and (max-width: 850px) {
        .over-tour {
            padding: 1rem;
            flex-direction: column;
            align-items: normal;
            gap: 1rem;
            .image {
                width: 100%;
                max-width: none;
                aspect-ratio: 2.5;
            }
            .expand {
                display: none;
            }
        }
    }
`
export default function TourMain16 (props){
  const location = useLocation()
  const navigate = useNavigate();
  const {data: dataRaw, lan, tour} = props;
  let newData = tour;
  let routes = [];
  for (let i = 0; i < newData.ROUTES.length; i++) {
    const route = newData.ROUTES[i];
    const next = newData.ROUTES[(i + 1 === newData.ROUTES.length) ? 0 : i + 1];
    let filter = newData.TICKETS.filter((v) => v.Toure_Route_Id_From === route.Toure_Route_Id);
    for (let j = 0; j < filter.length; j++) {
      filter[j].from = route;
      filter[j].to = next;
    }
    routes.push({
      ...route,
      tickets: filter
    })
  }
  const [tourData, setTourData] = useState({
    ...tour,
    ROUTES: routes,
  })
  const data = JSON.parse(dataRaw);
  useEffect(() => {
    // setMetaTags("Luxintrip", "", "noindex");

  }, []);
  useEffect(() => {
    // setMetaTags("Luxintrip", "", "noindex");
    let newData = tour;
    let routes = [];
    for (let i = 0; i < newData.ROUTES.length; i++) {
      const route = newData.ROUTES[i];
      const next = newData.ROUTES[(i + 1 === newData.ROUTES.length) ? 0 : i + 1];
      let filter = newData.TICKETS.filter((v) => v.Toure_Route_Id_From === route.Toure_Route_Id);
      for (let j = 0; j < filter.length; j++) {
        filter[j].from = route;
        filter[j].to = next;
      }
      routes.push({
        ...route,
        tickets: filter
      })
    }
    setTourData({
      ...tour,
      ROUTES: routes,
    });
  }, [tour]);
  useEffect(() => {
    let title = "Tour Information";

    if (tour?.Tour_Name) {
        title = lan.filename === "fa"
            ? `${tour.Tour_Name} - لوکسین تریپ`
            : `${tour.Tour_Name} - Luxintrip`;
    }
    setMetaTags(title, "", (tour?.Tour_Indexable) ? "" : "noindex");
    if (tour?.Tour_Name) {
      let trip = {
        "@type": "Trip",
        "@id": "https://luxintrip.com" + location.pathname + "/#Trip",
        "url": "https://luxintrip.com" + location.pathname,
        "name": tour.Tour_Name,
        "description": tour.Tour_Desc,
        "itinerary": [
          {
            "@type": "City",
            "name": (lan.filename === "fa") ? tour.City_Name : tour.City_EnName,
            "description": (lan.filename === "fa") ? tour.City_Name : tour.City_EnName,
          },
        ],
        "tripOrigin": {
          "@type": "Country",
          "name": (lan.filename === "fa") ? "ایران" : "Iran",
          "description": (lan.filename === "fa") ? "ایران" : "Iran",
        },
      }
      setReachDataType("Trip", trip);
    }
}, [tour, lan]);
  let agencyData = {};
  if(tour.AGENCY.length){
    agencyData = tour.AGENCY[0]
  }
  return (
    <Styles>
      <div className='back-drop'>
        {
            (tour.Tour_Image) ? (
                <img src={tour.Tour_Image} alt={"background"} onError={(e) => e.target.style.opacity = 0}/>
            ) : ""
        }
      </div>
      <div className='over-tour'>
        <div className='image'>
          <IconRouting className={"icon-def"}/>
          {
              (tour.Tour_Image) ? (
                  <img src={tour.Tour_Image} alt={tour.Tour_Name} onError={(e) => e.target.style.opacity = 0}/>
              ) : ""
          }
        </div>
        <div className='base'>
          <h1 className='title1'>
            {lan.filename === "fa" ? tour.Tour_Name : tour.Tour_EnName}
          </h1>
          <div className='desc'>
            <IconBuilding/>
            <div className='text'>
              {lan.filename === "fa" ? tour.Tour_Desc : tour.Tour_EnDesc}
            </div>
          </div>
          {
            (tour.City_Name && tour.Country_Name) ? (
              <>
              <div className='desc' style={{alignItems: "center"}}>
                <IconLocation/>
                {
                  lan.filename === "fa" ? tour.Country_Name : tour.Country_En_Name
                } - {
                  lan.filename === "fa" ? tour.City_Name : tour.City_En_Name
                }
              </div>
              </>
            ) : ""
          }
          {
            (tour.Agency_Name && tour.AGENCY.length) ? (
              <>
              <Link to={"/" + lan.filename + (tour.AGENCY[0].Agency_Type_Id === 1 ? "/travel-agency/" : "/tour-operator/") + agencyData.Continent_Url + "/"+ agencyData.Country_Url + "/"+ agencyData.City_Url + "/"+ tour.AGENCY[0].Agency_Url} className='desc' style={{alignItems: "center"}}>
                <IconAgency/>
                {Dictionery.organizer[lan.filename]}: {
                  lan.filename === "fa" ? tour.Agency_Name : tour.Agency_EnName
                } <span className='desc-link'>{"("}{Dictionery.moreAgency[lan.filename]}{")"}</span>
              </Link>
              <a href={`tel:${tour.AGENCY[0].Agency_Tel_no}`} className='desc' style={{alignItems: "center"}}>
                <IconAgency/>
                {Dictionery.organizerTel[lan.filename]}:<span style={{direction: "ltr"}}>{tour.AGENCY[0].Agency_Tel_no}</span>
              </a>
              </>
            ) : ""
          }
          {
            (tour.Currency_Id && tour.Tour_Min_Price) ? (
              <>
              <div className='desc big' style={{alignItems: "center"}}>
                {DictioneryPanel.packagesDict.startingPrice[lan.filename]}: <span className='desc-link'>{formatPrice(tour.Tour_Min_Price)}</span> {tour.Currency_Name} 
              </div>
              </>
            ) : ""
          }
        </div>
        <div className='end'>
          
        </div>
      </div>
      {
        (tour.Currency_Id && tour.Tour_Min_Price && false) ? (
          <>
          <div className='buy'>
            <div className='price big' style={{alignItems: "center"}}>
              {DictioneryPanel.packagesDict.startingPrice[lan.filename]}: <span className='desc-link'>{formatPrice(tour.Tour_Min_Price)}</span> {tour.Currency_Name} 
            </div>
            <div className='actions'>
              {
                (!props.user.API_TOKEN) ? (
                  <TextBtn2
                    text={DictioneryPanel.packagesDict.buy[lan.filename]}
                    onclick={() => {
                      props.openLoginDialog(() => {
                        console.log("navigate")
                        navigate("/" + lan.filename + "/buy-tour/" + tour.Tour_Id)
                      })
                    }}
                    newType={4}
                  />
                ) : (
                  <TextBtn2
                    text={DictioneryPanel.packagesDict.buy[lan.filename]}
                    link={"/" + lan.filename + "/buy-tour/" + tour.Tour_Id}
                    newType={4}
                  />
                )
              }
              
            </div>
          </div>
          </>
        ) : ""
      }
      <div className='box-details'>
        <TourDetailsDatesCartV2 data={tourData} lang={lan.filename} loading={false}/>
        <TourDetailsFacilityCartV2 data={tourData} lang={lan.filename} loading={false}/>
        <TourDetailsTravelPlanCartV2 data={tourData} lang={lan.filename} loading={false}/>
        <TourDetailsServicesCartV2 data={tourData} lang={lan.filename} loading={false}/>
        <TourDetailsHotelsCartV2 data={tourData} lang={lan.filename} loading={false}/>
      </div>
    </Styles>
  )
}

